import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { C17SideMediaAssetProps } from './C17SideMediaAsset.types';
import { CreateSideMediaAssetModel } from './C17SideMediaAsset.service';
import { Container, SideMediaAsset } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { Text as JssText } from '@sitecore-jss/sitecore-jss-nextjs';
import { PropsWithChildren } from 'react';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C17SideMediaAssetProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = CreateSideMediaAssetModel(props);

  if (isEditing) {
    const Field = (props?: PropsWithChildren) => (
      <div style={{ display: 'grid', gap: '0.5rem' }}>{props?.children}</div>
    );

    return (
      <SwitchToPreviewMessage componentName={props.rendering.componentName}>
        <Container>
          <div style={{ display: 'grid', gap: '1.5rem' }}>
            <Field>
              <b>Headline:</b>
              {model.headline}
            </Field>
            <Field>
              <b>Video ID:</b>
              <JssText field={props?.fields?.VideoId} />
            </Field>
            <Field>
              <b>Image:</b>
              {model.image}
            </Field>
            <Field>
              <b>Image CTA Link:</b>
              {model.imageCtaLink}
            </Field>
            <Field>
              <b>Image caption:</b>
              {model.imageCaption}
            </Field>
            <Field>
              <b>Support copy:</b>
              {model.supportCopy}
            </Field>
          </div>
        </Container>
      </SwitchToPreviewMessage>
    );
  }

  return (
    <SideMediaAsset
      id={props.params?.AnchorLinkTargetName}
      className={translationClasses(props.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};
